export default {
  setTitlesMenu(state, payload) {
    state.titleMenus = payload.titles;
  },

}